<div class="single-form" fxLayout="column" fxLayoutAlign="space-between center" fxFlexFill>
  
  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="padding-25 mat-elevation-z5" fxFlex="370px" fxFlex.sm="80%" fxFlex.lt-sm="90%">
      <form [formGroup]="forgotPasswordForm" fxLayout="column" (ngSubmit)="forgotPasswordForm.valid && onSubmit(forgotPasswordForm.value)" autocomplete="off" autocorrect="off" fxLayoutGap="25px" novalidate>

        <!--Image Logo-->
        <img id="id_forget_pass_img_logo" class="logo" src="assets/images/swiftrewards-icon.png" alt="E-Science Logo">

        <!--Statement Logo-->
        <!-- <h2 class="mat-display-1 mat-primary-color">E-Science Corporation</h2> -->

        <mat-label class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
          {{errorMessage}}
        </mat-label>

        <mat-form-field>
          <input id="id_forget_pass_txtbox_user" matInput [placeholder]="'LABEL_USERNAME' | translate" formControlName="username" autocomplete="off" required>
          <mat-error *ngIf="forgotPasswordForm.controls['username'].hasError('required')">
            {{ 'MSG_ERROR_USERNAME_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="forgotPasswordForm.controls['username'].hasError('notExisting')">
            {{ 'MSG_ERROR_USERNAME_NOT_EXISTING' | translate }}
          </mat-error>
        </mat-form-field>

        <button id="id_forget_pass_btn_send_veri" color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">
          {{ (isSubmitting ? 'LABEL_SENDING' : 'LABEL_SEND_VERIFICATION_CODE') | translate }}
        </button>

        <div fxLayout="column">
          <button mat-button 
            id="id_forget_pass_btn_have_code"
            type="button"
            routerLink="../reset-password" 
            [queryParams]="forgotPasswordForm.controls['username'].valid ? { username: forgotPasswordForm.controls['username'].value } : {}"
            color="primary">
            {{ 'LABEL_ALREADY_HAVE_VERIFICATION_CODE' | translate }}
          </button>
  
          <button mat-button 
            id="id_forget_pass_btn_return"
            type="button"
            routerLink="../login" 
            [queryParams]="forgotPasswordForm.controls['username'].valid ? { username: forgotPasswordForm.controls['username'].value } : {}"
            color="primary">
            {{ 'LABEL_RETURN_TO_LOGIN' | translate }}
          </button>
        </div>

      </form>
    </mat-card>
  </div>
  
  <div fxFlexAlign="end" class="width-100">
    <esc-footer></esc-footer>
  </div>
</div>